import { AllSavedFilters, FilterKeys, PageType } from '@utils/pageConfig/Types';
import axios from 'axios';
import { environment } from '@environments/environment';
import { cloneDeep } from 'lodash';
import { ProductType, SaveFilterParam } from '@pages/product-analyzer/Product';

export const getSavedFilters = async (
  userId: string | undefined,
  clientId: number,
  productType: ProductType,
): Promise<AllSavedFilters[]> => {
  const emptyResponse: AllSavedFilters[] = [
    { pageType: PageType.CATEGORY_LEADERBOARD, savedFilters: [] },
    { pageType: PageType.RETAILER_OVERVIEW, savedFilters: [] },
    { pageType: PageType.OPPORTUNITY_REVIEW, savedFilters: [] },
    { pageType: PageType.PERFORMANCE_ANALYSIS, savedFilters: [] },
    { pageType: PageType.TRADING_ASSISTANT, savedFilters: [] },
    { pageType: PageType.RI_PRODUCT, savedFilters: [] },
    { pageType: PageType.EXPLORE, savedFilters: [] },
  ];

  try {
    if (!userId || clientId === -1) {
      return emptyResponse;
    }

    let { data } = await axios.get<AllSavedFilters[]>(
      `${environment.baseUrl}/v2/saved-filters?clientId=${clientId}&productType=${productType}`,
      {
        headers: {
          userId: userId,
        },
        params: {},
      },
    );
    return data;
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err}`);
  }
};

export const addSavedFilter = async ({
  pageType,
  productType,
  name,
  country,
  clientId,
  userId,
  periodicity,
  filters,
}: SaveFilterParam) => {
  const filtersToPost = cloneDeep(filters);
  filtersToPost.forEach(
    (filter: { filterKey: FilterKeys; filterTitle: string; options: any[] }) =>
      (filter.options = filter.options.flatMap((e) => e.label)),
  );

  const request = {
    pageType,
    name,
    country,
    clientId,
    userId,
    periodicity: periodicity ? periodicity.toUpperCase().replace(/\s/g, '') : '',
    filters: filtersToPost,
  };
  try {
    const { status } = await axios.post(`${environment.baseUrl}/v2/saved-filters?productType=${productType}`, request, {
      params: {},
    });
    return status;
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err}`);
  }
};

export const deleteSavedFilter = async (
  pageType: PageType,
  productType: ProductType,
  name: string,
  userId: string,
  clientId: number,
) => {
  try {
    let { status } = await axios.delete(
      `${environment.baseUrl}/v2/saved-filters?pageType=${pageType}&name=${encodeURIComponent(
        name,
      )}&clientId=${clientId}&productType=${productType}`,
      {
        headers: {
          userId: userId,
        },
      },
    );
    return status;
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err}`);
  }
};
